import React from 'react';
import { Stack, Box, StackProps } from '@hover/blueprint';
import Content from './Content';
import { IMeasureRoofStep } from '../../../interfaces/IMeasureRoofStep';

interface Props extends StackProps {
  step: IMeasureRoofStep;
}

const MAX_IMAGE_WIDTH = '584px';

const Step: React.FC<Props> = ({ step, ...rest }) => (
  <Stack
    w="100%"
    alignItems="center"
    maxW={{ base: '2xl', desktop: '1312px' }}
    direction={{ base: 'column', desktop: 'row' }}
    px={{ base: 500, desktop: '56px' }}
    spacing={{
      base: !step.isReversed ? 0 : 800,
      desktop: !step.isReversed ? 600 : 'auto',
    }}
    py={{ base: 700, desktop: 1000 }}
    {...rest}
  >
    {!step.isReversed && (
      <Box
        maxW={{ base: '100%', desktop: MAX_IMAGE_WIDTH }}
        minW={{ base: 'auto', desktop: MAX_IMAGE_WIDTH }}
        d={{ base: 'none', desktop: 'flex' }}
      >
        {step.image}
      </Box>
    )}
    <Content
      content={step.content}
      heading={step.heading}
      stepNumber={step.id}
    />
    <Box
      justifyContent={{ base: 'center', desktop: 'flex-end' }}
      pt={{ base: !step.isReversed ? 800 : 0, desktop: 0 }}
      maxW={{ base: '100%', desktop: MAX_IMAGE_WIDTH }}
      minW={{ base: 'auto', desktop: MAX_IMAGE_WIDTH }}
      d={{ base: 'flex', desktop: !step.isReversed ? 'none' : 'flex' }}
    >
      {step.image}
    </Box>
  </Stack>
);

export default Step;
